import React, {PureComponent} from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import './DemoDialog.scss'
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import axios from "axios";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import ShipItDemoImage from "../../../../../resources/images/ShipitDemoOrange.png";

export default class DemoDialog extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            todayUsage: 0,
            isDemoExpandAvailable: false
        };
    }

    componentDidMount() {
        this.initTodayUsage();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (!this.props.open && nextProps.open)
            this.initTodayUsage();
    }

    async initTodayUsage() {
        const {data: todayNumberOfOrders} = await axios.get('/api/v2a/getTodayNumberOfOrders', {params: {bid: this.props.match.params.bid}});

        this.setState({
            todayUsage: todayNumberOfOrders
        });

        if (this.state.todayUsage >= this.props.dailyLimit) {
            const {data: isDemoExpandAvailable} = await axios.get('/api/v2a/isDemoExpandAvailable', {params: {bid: this.props.match.params.bid}});

            this.setState({
                isDemoExpandAvailable: isDemoExpandAvailable
            });
        } else {
            this.setState({
                isDemoExpandAvailable: false
            });
        }
    }

    handleClose() {
        if (this.props.onClose)
            this.props.onClose();
    }

    async handleExpandDailyLimitClicked() {
        const {data: isExpandWorked} = await axios.get('/api/v2a/expandDemo', {params: {bid: this.props.match.params.bid}});

        if (isExpandWorked) {
            this.props.fetchBusiness(this.props.match.params.bid);
        }
    }

    render() {
        return (
            <Dialog
                className="demo-dialog"
                open={this.props.open}
                onClose={this.handleClose.bind(this)}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    <div className="shipit-demo-logo-container">
                        <img className="shipit-demo-logo" src={ShipItDemoImage}/>
                    </div>
                </DialogTitle>
                <DialogContent>
                    {
                        this.props.fetching ?
                            <div className="loading-wrapper">
                                <CircularProgress/>
                            </div>
                            :
                            <div>
                                {
                                    this.state.todayUsage >= this.props.dailyLimit ?
                                        <div>
                                            הזמן עובר מהר כשנהנים!
                                            <br/>
                                            ניצלתם את מלוא מכסת המשלוחים היומית שהוגדרה לעסק
                                            ({this.props.dailyLimit} משלוחים).
                                            <br/><br/>
                                            מכסת המשלוחים תתאפס ב00:00 ותוכלו להמשיך להנות מShipit.
                                            <br/><br/>
                                            {this.state.isDemoExpandAvailable ?
                                                <div className="demo-expand-container">
                                                    <Button onClick={this.handleExpandDailyLimitClicked.bind(this)}
                                                            variant="contained"
                                                            color="secondary">
                                                        הרחב באופן חד פעמי את המכסה היומית
                                                    </Button>
                                                    <br/>
                                                </div>
                                                :
                                                false
                                            }
                                            מעוניינים להגדיל את המכסה היומית? אנא צרו עימנו קשר ובקשתכם תעבור לטיפול.
                                            <br/>
                                            דרכי התקשרות: במייל support@shipit.tech או במספר הטלפון 0505631600.
                                        </div>
                                        :
                                        <div>
                                            באפשרותכם לנצל עוד {this.props.dailyLimit - this.state.todayUsage} משלוחים
                                            עד לסוף היום.
                                            <br/>
                                            מתחילת היום נוצלו {this.state.todayUsage}/{this.props.dailyLimit} משלוחים.
                                            <br/><br/>
                                            מעוניינים להגדיל את המכסה היומית? אנא צרו עימנו קשר ובקשתכם תעבור לטיפול.
                                            <br/>
                                            דרכי התקשרות: במייל support@shipit.tech או במספר הטלפון 0505631600.
                                        </div>
                                }
                            </div>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose.bind(this)} variant="contained" color="primary" autoFocus>
                        סגור
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}